import styled from 'styled-components';

export const ErrorWrapper = styled.div`
  width: 100vw;
  min-height: 100vh;
  text-align: center;
  padding: 15vh 20vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img{
    width:15rem
  }
`;
export const ErrorCentralText = styled.h1`
  color: ${(p) => p?.theme?.colors?.accent?.primary};
  margin-top: 80px;
`;

export const ErrorSmallText = styled.span`
  display: block;
  color: black;
  margin: 40px 0;
  word-break: break-word
`;
